import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import './Onboarding.css';
import './genarel.css';

import Btn from '../components/common/btn.jsx';

const Onboarding1 = () => {
    const wrapperRef = useRef(null);
    const squareOuterRef = useRef(null);
    const squareInnerRef = useRef(null);
    const archRef = useRef(null);
    const iconRef = useRef(null);
    const titleRef = useRef(null);
    const paraRef = useRef(null);
    const dotsRef = useRef(null);
    const btnRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set([squareOuterRef.current, squareInnerRef.current], { opacity: 0, scale: 0.6, rotation: 0 });
        gsap.set(archRef.current, { opacity: 0, y: -60 });
        gsap.set(iconRef.current, { opacity: 0, scale: 0, rotation: -30 });
        gsap.set(titleRef.current, { opacity: 0, x: -40 });
        gsap.set(paraRef.current, { opacity: 0, y: 20 });
        gsap.set(dotsRef.current, { opacity: 0, y: 10 });
        gsap.set(btnRef.current, { opacity: 0, y: 30 });

        tl.to(squareOuterRef.current, { opacity: 1, scale: 1, rotation: 12, duration: 0.8 })
          .to(squareInnerRef.current, { opacity: 1, scale: 1, rotation: -8, duration: 0.7 }, '-=0.5')
          .to(archRef.current, { opacity: 1, y: 0, duration: 0.6 }, '-=0.4')
          .to(iconRef.current, { opacity: 1, scale: 1, rotation: 0, duration: 0.5 }, '-=0.3')
          .to(titleRef.current, { opacity: 1, x: 0, duration: 0.6 }, '-=0.2')
          .to(paraRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.3')
          .to(dotsRef.current, { opacity: 1, y: 0, duration: 0.4 }, '-=0.2')
          .to(btnRef.current, { opacity: 1, y: 0, duration: 0.5 }, '-=0.2');
    }, []);

    return (
        <div className="ob-wrapper" ref={wrapperRef}>
            <div className="mobile-container">
                <main className="ob-screen">

                    <div className="ob-visual-area" aria-hidden="true">
                        <div className="ob-square-outer" ref={squareOuterRef}></div>
                        <div className="ob-square-dashed" ref={squareInnerRef}></div>
                        <div className="ob-arch" ref={archRef}>
                            <span className="ob-icon" ref={iconRef}>
                                <svg width="92" height="92" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                                    <circle cx="9" cy="9" r="1.2" fill="white" stroke="none"/>
                                    <circle cx="15" cy="9" r="1.2" fill="white" stroke="none"/>
                                    <path d="M12 2v2M12 20v2M2 12h2M20 12h2"/>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <div className="ob-body">
                        <h1 className="ob-title" ref={titleRef}>Discover Creative Excellence</h1>
                        <p className="ob-para" ref={paraRef}>Explore cutting-edge design exhibitions, architecture showcases, and creative innovations from Egypt and beyond.</p>
                    </div>

                    <div className="ob-dots" ref={dotsRef} role="img" aria-label="Step 1 of 3">
                        <span className="ob-dot ob-dot--active" aria-hidden="true"></span>
                        <span className="ob-dot" aria-hidden="true"></span>
                        <span className="ob-dot" aria-hidden="true"></span>
                    </div>

                    <div className="ob-btn-wrap" ref={btnRef}>
                        <Link to="/onboarding2" className="ob-link" aria-label="Go to the next onboarding step">
                            <Btn btnt="NEXT" />
                        </Link>
                    </div>

                </main>
            </div>
        </div>
    );
};

export default Onboarding1;